import { useMemo } from 'react';

interface PublicationRecordsProps {
  publication: any;
  type?: string;
}

interface RecordItem {
  key: string;
  icon: string;
  value: string;
}

export const usePublicationRecords = ({ publication, type }: PublicationRecordsProps) => {
  
  // Default records para autos usados
  const defaultRecords: RecordItem[] = useMemo(() => [
    {
      key: "personal_use",
      icon: "https://res.cloudinary.com/gtt-dev/image/upload/v1702401673/static/SUV_ucqezk.svg",
      value: "Sin datos de uso comercial o personal"
    },
    {
      key: "sole_owner",
      icon: "https://res.cloudinary.com/gtt-dev/image/upload/v1701354668/static/Accountant_wiq9rp.svg",
      value: "Sin informacion de propietarios"
    },
    {
      key: "accidents_reported",
      icon: "https://res.cloudinary.com/gtt-dev/image/upload/v1702394054/static/Crash_bvmfw6.svg",
      value: "Sin datos sobre accidentes reportados"
    }
  ], [publication?.vehicle_data?.mileage, publication?.vehicle_data?.year]);

  // Default records para autos nuevos
  const defaultRecordsNew: RecordItem[] = useMemo(() => [
    {
      key: "personal_use",
      icon: "https://res.cloudinary.com/gtt-dev/image/upload/v1702401673/static/SUV_ucqezk.svg",
      value: "Vehículo sin usos anteriores"
    },
    {
      key: "sole_owner",
      icon: "https://res.cloudinary.com/gtt-dev/image/upload/v1701354668/static/Accountant_wiq9rp.svg",
      value: "Vehículo sin propietarios anteriores"
    },
    {
      key: "accidents_reported",
      icon: "https://res.cloudinary.com/gtt-dev/image/upload/v1702394054/static/Crash_bvmfw6.svg",
      value: "Auto nuevo, no ha sufrido accidentes"
    }
  ], []);
  
  const getRecordsToShow = (): RecordItem[] => {
    const allowedKeys = ['personal_use', 'sole_owner', 'accidents_reported'];

    const recordsData = publication?.record || publication?.detail;

    if (recordsData && Array.isArray(recordsData) && recordsData.length > 0) {
      
      const filteredDetail = recordsData.filter((item: RecordItem) => 
        allowedKeys.includes(item.key)
      );
      
      const baseDefaults = publication?.condition === 'new' ? defaultRecordsNew : defaultRecords;

      const detailMap = new Map<string, RecordItem>(
        filteredDetail.map((item: RecordItem) => [item.key, item])
      );

      const mergedRecords: RecordItem[] = baseDefaults.map((defaultItem: RecordItem): RecordItem => {
        const detailItem = detailMap.get(defaultItem.key);
        if (detailItem) {
          return detailItem;
        }
        return defaultItem;
      });

      return mergedRecords;
    }
    
    if (type === "salePost") {
      return publication?.records || defaultRecords;
    }
    
    const result = publication?.condition === 'new' ? defaultRecordsNew : defaultRecords;
    return result;
  };

  return {
    recordsToShow: getRecordsToShow(),
    defaultRecords,
    defaultRecordsNew,
  };
};
